<template>
    <form
        class="mt-[44px] grid-cols-layout border-b border-gray-300 pb-5 lg:grid"
        @submit.prevent="$emit('update', selectedLanguage)"
    >
        <div class="mb-6 lg:mb-0 lg:mt-4">
            <h3
                class="mb-[5px] text-lg font-medium leading-normal tracking-small text-gray-800"
            >
                Editor language
            </h3>
            <p class="max-w-xs text-sm text-gray-500">
                Select your preferred TOPOL Editor interface language.
            </p>
        </div>

        <div class="mx-auto w-full rounded-[6px] bg-white shadow-card lg:mx-0">
            <div class="flex flex-wrap border-b border-gray-200 pl-6">
                <SelectInput
                    v-model="selectedLanguage"
                    class="my-5 w-full pr-6 sm:mr-6 sm:w-80 sm:pr-0"
                    :data="languages"
                    placeholder="Select language"
                    label="Editor language"
                    search
                />
            </div>
            <div class="flex justify-end">
                <div class="my-3 pr-6">
                    <LockableButton
                        :disabled="selectedLanguage === editorSettings.language"
                        type="submit"
                        color="yellow"
                        size="sm"
                        :locked="!hasAnyProSubscriptionOrTrial"
                        lock-message="You need a PRO subscription to update editor settings."
                    >
                        Save changes
                    </LockableButton>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup lang="ts">
import IEditorSettings from '@/types/Settings/IEditorSettings';
import { PropType } from 'vue';
import languages from '@/data/editor-languages';

const props = defineProps({
    editorSettings: {
        type: Object as PropType<IEditorSettings>,

        default: () => {},
    },
});

defineEmits(['update']);

const { hasAnyProSubscriptionOrTrial } = useSubscriptions();

const selectedLanguage = ref<string>(props.editorSettings.language);
</script>
